// External
import { createContext } from 'react';

const ListOfProductsContext = createContext();
export default ListOfProductsContext;